module.exports = __webpack_public_path__ + "img/zh.ecc93e23.png";